import "@/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Contact, Menu, X } from "lucide-react";

import { Button } from "./components/ui/button";
import { Toaster } from "./components/ui/sonner";

// Pages
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Blog from "./pages/Blog";
import ServiceDetail from "./pages/ServiceDetail";
import Careers from "./pages/Careers";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

import Founder from "./pages/Founder";
import Team from "./pages/Team";
import Values from "./pages/Values";
import Journey from "./pages/Journey";
import WhyUs from "./pages/WhyUs";
import JoinUs from "./pages/JoinUs";
import ContactUs from "./pages/ContactUs";
// Admin
import AdminLogin from "./pages/AdminLogin";
import AdminTeam from "./pages/AdminTeam";


import ProtectedRoute from "./components/ProtectedRoute";
 import AdminDashboard from "./pages/AdminDashboard";
import AdminLayout from "./admin/AdminLayout"
// ---------------- HEADER ----------------
// ---------------- HEADER ----------------
const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const scrollToContact = () => {
    if (location.pathname === "/") {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/#contact";
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="font-serif text-2xl font-bold text-black">
            skyretieducore
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="/#services" className="hover:text-black">Services</a>
            <Link to="/portfolio">Portfolio</Link>
            <Link to="/pricing">Pricing</Link>

            {/* Company Dropdown */}
            <div className="relative group">
              <button className="hover:text-black font-medium">
                Company
              </button>

              <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all">
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/about">About Us</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/founder">Founder</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/team">Team</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/values">Values</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/journey">Journey</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/why-us">Why Us</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/careers">Careers</Link>
              </div>
            </div>

            <Link to="/blog">Blog</Link>
            <Button onClick={scrollToContact}>Contact Us</Button>
          </nav>

          {/* Mobile Toggle */}
          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>

        {/* Mobile Nav */}
        {mobileMenuOpen && (
          <nav className="md:hidden py-4 flex flex-col gap-3">
            <a href="/#services" onClick={() => setMobileMenuOpen(false)}>Services</a>
            <Link to="/portfolio" onClick={() => setMobileMenuOpen(false)}>Portfolio</Link>
            <Link to="/pricing" onClick={() => setMobileMenuOpen(false)}>Pricing</Link>
            <Link to="/about" onClick={() => setMobileMenuOpen(false)}>About</Link>
            <Link to="/founder" onClick={() => setMobileMenuOpen(false)}>Founder</Link>
            <Link to="/team" onClick={() => setMobileMenuOpen(false)}>Team</Link>
            <Link to="/values" onClick={() => setMobileMenuOpen(false)}>Values</Link>
            <Link to="/journey" onClick={() => setMobileMenuOpen(false)}>Journey</Link>
            <Link to="/why-us" onClick={() => setMobileMenuOpen(false)}>Why Us</Link>
            <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>Blog</Link>

            <Button onClick={scrollToContact}>Contact Us</Button>
          </nav>
        )}
      </div>
    </header>
  );
};


// ---------------- APP ----------------
function App() {
  return (
    <div className="App">
      <div className="pt-16">
      <Router>
        <Header />


        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Blog />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          {/* Company Pages */}
          <Route path="/founder" element={<Founder />} />
          <Route path="/team" element={<Team />} />
          <Route path="/values" element={<Values />} />
          <Route path="/journey" element={<Journey />} />
          <Route path="/why-us" element={<WhyUs />} />
          <Route path="/join" element={<JoinUs />} />
          <Route path="/Contact" element={<ContactUs/>} />
          {/* Admin */}
          <Route path="/admin-login" element={<AdminLogin />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="team" element={<AdminTeam />} />
          </Route>

        </Routes>
      </Router>

      <Toaster />
    </div>
    </div>
  );
}



export default App;
